import { useEffect } from "react";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Eyebrow } from "@/components/site/Reveal";
import { TradeForm } from "@/components/site/trade/TradeForm";

export default function TradeIn() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Troca · Avalie seu seminovo | RC iPhones";
  }, []);
  return (
    <SmoothScroll>
      <div className="grain min-h-screen bg-[#09090b] text-white">
        <Header />
        <main data-testid="trade-page" className="mx-auto max-w-[1440px] px-5 pb-24 pt-[136px] sm:px-8 lg:pt-32">
          <div className="max-w-2xl">
            <Eyebrow>Troca</Eyebrow>
            <h1 className="font-display mt-5 text-4xl font-extrabold leading-[0.95] tracking-[-0.04em] text-white sm:text-5xl lg:text-6xl">
              Use seu aparelho <span className="text-outline">na troca.</span>
            </h1>
            <p className="mt-5 text-base text-zinc-300">Responda as perguntas, anexe os prints e veja na hora uma avaliação estimada. A loja confere tudo e te responde no WhatsApp.</p>
          </div>
          <div className="mt-10 sm:mt-14">
            <TradeForm />
          </div>
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
